module.exports = __webpack_public_path__ + "media/categories/5007-3a80d592.svg";